<div class="loader-modal-overlay">
  <div class="loader-modal-content">
    @if (showSpinner) {
      <div class="spinner"></div>
    }
    <p class="loading-message">{{ message | translate }}</p>
  </div>
</div>
